export const FixedDatesDateRangeType = 'fixed-dates';
interface IFixedDatesDateRange {
    type: typeof FixedDatesDateRangeType;
    start: string; // YYYY-MM-DD
    end: string; // YYYY-MM-DD
}

export const DaysDateRangeType = 'days';
interface IDaysDateRange {
    type: typeof DaysDateRangeType;
    days: number;
}

export const TextDateRangeType = 'text';
interface ITextDateRange {
    type: typeof TextDateRangeType;
    text: string;
}

export type DateRange = IFixedDatesDateRange | IDaysDateRange | ITextDateRange;
export type DateRangeMode = DateRange['type'];

export const DateRangeSeparator = '|';
